<template>
	<div class="main-resource-content__warehouse">
		<div class="warehouse__header">
			<div class="warehouse__state">
				<strong>{{ translate("ui.current_state") }}</strong>
				<div class="current-state">
					<strong>
						{{ formatNumber(animatedStorageValue) }}
					</strong>
					<strong>
						{{ ` / ${formatNumber(maxStorageCapacity)}` }}
					</strong>
					<AppMainIcon :iconName="currency" :iconSize="16" />
				</div>
			</div>
			<div class="divider" />
			<div class="warehouse__state">
				<strong>{{ translate("ui.required") }}</strong>
				<div class="required">
					<strong>
						{{ formatNumber(value) }}
					</strong>
					<AppMainIcon :iconName="currency" :iconSize="16" />
				</div>
			</div>
		</div>
		<HorizontalDecorDivider />
		<span class="warehouse__not-enough" v-html="notEnoughStorage" />
		<strong class="warehouse__more-buildings">
			{{
				currency === ResourceType.ARMY
					? translate("ui.build_more_army_buildings")
					: translate("ui.buils_more_storage_buildings")
			}}
		</strong>
	</div>
</template>

<script lang="ts" setup>
import AppMainIcon from "@/components/AppMainIcon.vue";
import HorizontalDecorDivider from "@/components/SVG/HorizontalDecorDivider.vue";
import { ResourceType } from "@/game/entities/config/resources";
import { formatNumber } from "@/utils/format";
import { translate } from "@/utils/translate";

defineProps<{
	currency: ResourceType;
	animatedStorageValue: number;
	maxStorageCapacity: number;
	value: number;
	notEnoughStorage: string;
}>();
</script>

<style lang="scss" scoped>
.main-resource-content__warehouse {
	@include flex-col-center;
	width: calc(100% - 1.5rem);
	height: 100%;

	.horizontal-decor-divider {
		margin: 0.75rem 0;
		width: 100%;

		:deep(path),
		:deep(rect) {
			fill: rgba(55, 38, 21, 0.6);
		}
	}

	.warehouse {
		&__header {
			@include flex-row-center;
			gap: 1.625rem;
			font-size: 0.875rem;

			.divider {
				opacity: 0.6;
				background-color: #372615;
				width: 0.063rem;
				height: 2.5rem;
			}
		}

		&__state {
			@include flex-col-center;
			gap: 0.25rem;
			line-height: 1rem;

			.current-state,
			.required {
				@include flex-row-center;
				gap: 0.25rem;
			}

			.current-state {
				strong {
					color: #cf0032;
					font-weight: 800;
					font-size: 0.875rem;
					text-align: center;
				}
			}
		}

		&__state,
		&__not-enough {
			:deep(.icon) {
				margin-bottom: -0.25rem;
			}
		}

		&__not-enough,
		&__more-buildings {
			padding: 0 1.25rem;
			font-size: 0.875rem;
			text-align: center;
		}
	}
}
</style>
